<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('system.userName')">
                <a-input v-model="queryParam.userName" :placeholder="$t('system.inputPlaceholder')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('system.phoneNumber')">
                <a-input v-model="queryParam.phoneNumber" :placeholder="$t('system.inputPlaceholder')" allow-clear />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('system.status')" prop="status">
                  <a-select v-model="queryParam.status" :placeholder="$t('system.selectStatus')" style="width: 100%" allow-clear>
                    <a-select-option v-for="(d, index) in dict.type['sys_normal_disable']" :key="index"
                                     :value="d.value">{{ d.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('system.createTime')">
                  <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD"
                                  allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
                  <span class="table-page-search-submitButtons"
                        :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                    <a @click="toggleAdvanced" style="margin-left: 8px">
                      {{ advanced ? $t('system.collapse') : $t('system.expand') }}
                      <a-icon :type="advanced ? 'up' : 'down'" />
                    </a>
                  </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:user:add']">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)"
                  v-hasPermi="['system:user:edit']">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:user:remove']">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>


      <!-- 创建/编辑用户表单组件 -->
      <create-form ref="createForm" :deptOptions="deptOptions" :statusOptions="dict.type['sys_normal_disable']"
                   :sexOptions="dict.type['sys_user_sex']" @ok="getList" @select-tree="getTreeselect" />
      <!-- 修改密码抽屉 -->
      <reset-password ref="resetPassword" />
      <!-- 分配角色模态框 -->
      <auth-role ref="authRole" />
      <!-- 上传文件 -->
      <import-excel ref="importExcel" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
               :bordered="tableBordered" :scroll="{ x: 2000 }">
        <!-- 状态列：status 0=开启，1=关闭 -->
        <span slot="status" slot-scope="text, record">
              <a-popconfirm :ok-text="$t('common.ok')" @confirm="confirmHandleStatus(record)"
                            @cancel="cancelHandleStatus(record)">
                <span slot="title">{{ $t('system.confirmEnable') }}<b>{{ record.status ===  0 ? $t('system.enable') : $t('system.disable') }}</b>{{ record.nickName }}{{ $t('system.user') }}?</span>
                <a-switch :checked="record.status === 1 "  />
              </a-popconfirm>
            </span>


        <!-- 创建时间格式化显示 -->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <!-- 操作列：修改、删除、重置密码、分配角色（管理员用户不可操作） -->
        <span slot="operation" slot-scope="text, record" v-if="record.id !== 1">
              <a-space :size="8">
                <a-divider type="vertical" v-hasPermi="['video:user:edit']" />
                <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:user:edit']">
                  <a-icon type="edit" />
                  {{ $t('common.edit') }}
                </a>
                <a-divider type="vertical" v-hasPermi="['system:user:resetPwd', 'system:user:edit','system:user:remove']" />
                <a-dropdown v-hasPermi="['system:user:resetPwd', 'system:user:edit','system:user:remove']">
                  <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                    <a-icon type="double-right" />
                    {{ $t('common.more') }}
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item v-hasPermi="['system:user:resetPwd']">
                      <a @click="$refs.resetPassword.handleResetPwd(record)">
                        <a-icon type="key" />
                        {{ $t('system.resetPassword') }}
                      </a>
                    </a-menu-item>
                    <a-menu-item v-hasPermi="['system:user:edit']">
                      <a @click="$refs.authRole.handleAuthRole(record)">
                        <a-icon type="check-circle" />
                        {{ $t('system.assignRole') }}
                      </a>
                    </a-menu-item>

                     <a-menu-item v-hasPermi="['system:user:remove']">
                      <a @click="handleDelete(record)" v-hasPermi="['system:user:remove']">
                        <a-icon type="delete" />
                        {{ $t('common.delete') }}
                      </a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-space>
            </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
                    :total="total" :page-size="queryParam.pageSize" :showTotal="total => $t('table.total', { total })"
                    :rowKey="(record, index) => index + 1"
                    @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { pageUser, delUser, changeUserStatus, deptTreeSelect } from '@/api/system/user'
import AuthRole from './modules/AuthRole'
import ResetPassword from './modules/ResetPassword'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import DeptTree from './modules/DeptTree'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    AuthRole,
    ResetPassword,
    CreateForm,
    ImportExcel,
    DeptTree
  },
  mixins: [tableMixin],
  dicts: ['sys_normal_disable', 'sys_user_sex'],
  data() {
    return {
      // 用户列表数据
      list: [],
      // 表格选中行的key数组
      selectedRowKeys: [],
      // 表格选中行的完整数据
      selectedRows: [],
      // 高级搜索展开/收起状态
      advanced: false,
      // 是否禁用单个操作（选中行数不为1时禁用）
      single: true,
      // 是否禁用多个操作（未选中行时禁用）
      multiple: true,
      // 选中行的ID数组
      ids: [],
      // 表格加载状态
      loading: false,
      // 数据总数
      total: 0,
      // 部门树选项
      deptOptions: [{
        id: 0,
        label: '',
        children: []
      }],
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        {
          title: this.$t('system.userId'),
          dataIndex: 'id',
          width: '15%',
          align: 'center'
        },
        {
          title: this.$t('system.userName'),
          dataIndex: 'userName',
          width: '15%',
          align: 'center'
        },
        {
          title: this.$t('system.phoneNumber'),
          dataIndex: 'phoneNumber',
          width: '15%',
          align: 'center'
        },
        {
          title: this.$t('system.nickName'),
          dataIndex: 'nickName',
          width: '15%',
          align: 'center'
        },
        {
          title: this.$t('system.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: '15%',
          align: 'center'
        },
        {
          title: this.$t('system.createTime'),
          dataIndex: 'createTime',
          width: '30%',
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 200,
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    // 初始化：获取用户列表和部门树
    this.getList()
    this.getDeptTree()
  },
  methods: {
    /**
     * 部门树选择回调（供子组件调用）
     */
    getTreeselect() { },
    /** 查询用户列表 */
    getList() {
      this.loading = true
      pageUser(this.addDateRange(this.queryParam, this.dateRange)).then(response => {
        console.log(response);
        this.list = response.data.records
        this.total = Number(response.data.total);
        this.loading = false
      }
      )
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      deptTreeSelect().then(response => {
        this.deptOptions = response.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        deptId: undefined
      }
      this.handleQuery()
    },
    /**
     * 分页大小改变事件
     * @param {number} current - 当前页码
     * @param {number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /**
     * 分页改变事件
     * @param {number} current - 当前页码
     * @param {number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /**
     * 表格行选择改变事件
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /**
     * 点击部门节点
     * @param {number} deptId - 部门ID
     */
    clickDeptNode(deptId) {
      this.queryParam.deptId = deptId
      this.handleQuery()
    },
    /**
     * 确认修改用户状态
     * @param {Object} row - 用户行数据
     * status: 0=开启, 1=关闭
     */
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const text = row.status === 0 ? this.$t('system.enable') : this.$t('system.disable')
      const status = row.status === 1 ? 0 : 1
      changeUserStatus(row.id, status).then((res) => {
        if (res.success) {
          row.status = status
          this.$message.success(text + this.$t('common.success'), 3)
        }else{
          row.status = oldStatus
          this.$message.error(`${text}${this.$t('common.fail')}, ${res.message}`, 3)
        }
      }).catch(() => {
        this.$message.error(text + this.$t('common.error'), 3)
      })
    },
    /**
     * 取消修改用户状态（空方法，保留接口）
     * @param {Object} row - 用户行数据
     */
    cancelHandleStatus(row) {
    },
    /**
     * 删除用户
     * @param {Object} row - 用户行数据（单行删除）或 undefined（批量删除）
     */
    handleDelete(row) {
      const that = this
      const userIds = row.id || this.ids
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + userIds,
        onOk() {
          return delUser(userIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
            })
        },
        onCancel() { }
      })
    },
    /**
     * 导出用户数据
     * 导出当前查询条件下的所有数据，而非选中数据
     */
    handleExport() {
      const that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk() {
          that.download('system/user/export', {
            ...that.queryParam
          }, `user_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
